import React, { useState } from 'react';
import GameOfferCard from './GameOfferCard';
import './Profile.css';
import './OfferWall.css';

interface Offer {
  id: string;
  name: string;
  description: string;
  icon: string | null;
  type: string;
  action: string;
  featured?: boolean;
  payout?: number;
  category?: string;
}

const fakeGameOffers: Offer[] = [
  {
    id: 'candy-crush',
    name: 'Candy Crush Saga',
    description: 'Match 3 candy puzzles and reach level 50!',
    icon: 'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/64/c3/76/64c37621-2f23-b819-1f87-f12437d11ca2/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/460x0w.png',
    type: 'game',
    action: 'install',
    payout: 2.50,
    category: 'Puzzle'
  },
  {
    id: 'clash-royale',
    name: 'Clash Royale',
    description: 'Battle in real-time and reach Arena 5',
    icon: 'https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/96/db/3e/96db3e17-52e8-f5e0-922a-8cb706f70332/AppIcon-0-0-1x_U007emarketing-0-7-0-85-220.png/460x0w.png',
    type: 'game',
    action: 'install',
    payout: 3.75,
    category: 'Strategy',
    featured: true
  },
  {
    id: 'pokemon-go',
    name: 'Pokémon GO',
    description: 'Catch 20 different Pokémon species',
    icon: 'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/2b/1d/fa/2b1dfa15-2f75-866a-c1e9-b9557a870fd1/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/460x0w.png',
    type: 'game',
    action: 'install',
    payout: 4.20,
    category: 'Adventure'
  },
  {
    id: 'subway-surfers',
    name: 'Subway Surfers',
    description: 'Score 500,000 points in a single run',
    icon: 'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/2a/20/5e/2a205e9c-38c2-25b1-edf7-24e4fc12124a/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/460x0w.png',
    type: 'game',
    action: 'install',
    payout: 1.85,
    category: 'Arcade'
  },
  {
    id: 'roblox',
    name: 'Roblox',
    description: 'Play for 30 minutes and join 3 different games',
    icon: 'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/4d/f0/d0/4df0d037-96b0-1f9b-1dc7-13fdacd701d1/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/460x0w.png',
    type: 'game',
    action: 'install',
    payout: 5.00,
    category: 'Adventure',
    featured: true
  }
];

// Mark some as "in progress" for demo
const inProgressIds = ['clash-royale', 'roblox'];

interface OfferWallProps {
  userId?: string;
}

const OfferWall: React.FC<OfferWallProps> = ({ userId }) => {
  const [activeTab, setActiveTab] = useState<'all' | 'in_progress'>('all');

  const offersWithProgress = fakeGameOffers.map(offer => ({
    ...offer,
    isInProgress: inProgressIds.includes(offer.id)
  }));

  const filteredOffers = activeTab === 'all'
    ? offersWithProgress
    : offersWithProgress.filter(offer => offer.isInProgress);

  return (
    <div className="offerwall-profile-container">
      {/* Main header with logo and text */}
      <div className="offerwall-main-header">
        <img
          src="https://is1-ssl.mzstatic.com/image/thumb/Purple122/v4/4f/63/36/4f633667-97ac-389f-609c-704a7072ce43/AppIcon-1x_U007emarketing-0-7-0-85-220.png/460x0w.png"
          alt="Logo"
          className="offerwall-logo"
        />
        <h1 className="offerwall-title">Get free chat credits for using our favorite apps</h1>
      </div>

      {/* Tab buttons */}
      <div className="offerwall-profile-header">
        <div className="tab-container">
          <button
            onClick={() => setActiveTab('all')}
            className={`tab-button ${activeTab === 'all' ? 'active' : 'inactive'}`}
          >
            All ({fakeGameOffers.length})
          </button>
          <button
            onClick={() => setActiveTab('in_progress')}
            className={`tab-button ${activeTab === 'in_progress' ? 'active' : 'inactive'}`}
          >
            In Progress ({inProgressIds.length})
          </button>
        </div>
      </div>

      {/* Offers Section */}
      <div className="offers-section">
        <div className="offers-container">
          {filteredOffers.map((offer) => (
            <GameOfferCard key={offer.id} offer={offer} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default OfferWall;